import { render, staticRenderFns } from "./registerParcelStep1.vue?vue&type=template&id=78516bd6&scoped=true"
import script from "./registerParcelStep1.vue?vue&type=script&lang=js"
export * from "./registerParcelStep1.vue?vue&type=script&lang=js"
import style0 from "./registerParcelStep1.vue?vue&type=style&index=0&id=78516bd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78516bd6",
  null
  
)

export default component.exports